import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { EvaluatorService } from '@/infra/services/evaluator';

interface CreateEvaluatorParams {
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = EvaluatorService.getInstance();

export const useCreateEvaluator = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: CreateEvaluatorParams) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_LIST_EVALUATOR] });
			message.success(I18n.get('Evaluator created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on create evaluator'));
		}
	});
};
